import { render, staticRenderFns } from "./TestItemUploader.vue?vue&type=template&id=ccdd385e&scoped=true&"
import script from "./TestItemUploader.vue?vue&type=script&lang=js&"
export * from "./TestItemUploader.vue?vue&type=script&lang=js&"
import style0 from "./TestItemUploader.vue?vue&type=style&index=0&id=ccdd385e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdd385e",
  null
  
)

export default component.exports